export default "__VITE_ASSET__BLT8rAQ4__"